import { Link } from './link.js'

export * from './link.js'

export default Link
